
export const getURLParams = (paramNames) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const result = {};
    
    paramNames.forEach(paramName => {
        result[paramName] = params.get(paramName);
    });
    
    return result;
}